<template>
  <div class="ui-skeleton" :style="{ width, height }"></div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    width?: string;
    height?: string;
  }>(),
  {
    width: "100%",
    height: "1rem"
  }
);
</script>

<style scoped>
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.ui-skeleton {
  border-radius: var(--radius-sm);
  background: linear-gradient(90deg, var(--skeleton-0) 0%, var(--skeleton-1) 50%, var(--skeleton-0) 100%);
  background-size: 200% 100%;
  animation: shimmer 1.2s ease-in-out infinite;
}

@media (prefers-reduced-motion: reduce) {
  .ui-skeleton {
    animation: none;
  }
}
</style>
